export enum ProgressBarPalette {
  CLOUD = 0,
  GREEN = 1,
  PURPLE = 2,
  PINK = 3,
  ORANGE = 4,
  YELLOW = 5,
  PLATINUM = 6,
  GRAY = 7,
  DARK_GRAY = 8,
  EMERALD = 9,
}

export const ZERO_PROGRESS_BREAKPOINTS_WIDTH = '45px';
export const ZERO_PROGRESS_SMALL_WIDTH = '6px';
export const ZERO_PROGRESS_WIDTH = 1;
export const CHANGE_PROGRESS_POSITION_VALUE = 20;

export const ZERO_PROGRESS = 0;
export const MAX_PROGRESS = 100;

const HIGH_PROGRESS_THRESHOLD = 90;

export const round = (value: number, roundTo: number) =>
  Math.round(value * roundTo) / roundTo;

export const calculatePercent = (
  start: number,
  end: number,
  curr: number,
  params?: {
    roundTo: number;
    isRoundDownHighProgress?: boolean;
  }
) => {
  const res =
    start === end
      ? MAX_PROGRESS
      : ((curr - start) / (end - start)) * MAX_PROGRESS;
  let roundedRes = params?.roundTo ? round(res, params.roundTo) : res;

  if (params?.isRoundDownHighProgress && roundedRes > HIGH_PROGRESS_THRESHOLD) {
    roundedRes = Math.floor(res);
  }

  return curr < end && roundedRes >= MAX_PROGRESS
    ? Math.floor(res)
    : roundedRes;
};

export const isDotActive = (
  index: number,
  userProgress: number,
  dotsCount: number
): boolean =>
  (index === 0 && userProgress === 0) ||
  userProgress >= index * (100 / dotsCount);
